var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.$store.state.browser ? _vm.$store.state.browser.name:'',
    _vm.$store.state.browser ? _vm.$store.state.browser.os:''
  ],attrs:{"id":"app"}},[_c('MainView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }